import React from 'react';
import { Link } from 'react-router-dom';
import './FooterLinks.css';

function FooterLinks() {
	return (
		<div className="footer-links">
			<Link className="footer-link footer-link-primary" to="/how-to-play">
				How to Play
			</Link>
			<span className="footer-separator">|</span>
			<Link className="footer-link" to="/about">
				About
			</Link>
			<Link className="footer-link" to="/privacy">
				Privacy
			</Link>
			<Link className="footer-link" to="/terms">
				Terms
			</Link>
			<Link className="footer-link" to="/contact">
				Contact
			</Link>
		</div>
	);
}

export default FooterLinks;
